import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import JobsView from '../views/JobsView.vue'
import JobReviewView from '../views/JobReviewView.vue'

const routes = [
  { path: '/', name: 'login', component: LoginView },
  { path: '/dashboard', name: 'dashboard', component: DashboardView, meta: { requiresAuth: true } },
  { path: '/jobs', name: 'jobs', component: JobsView, meta: { requiresAuth: true } },
  { path: '/jobs/:id', name: 'job_review', component: JobReviewView, meta: { requiresAuth: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  if (to.name !== 'login' && to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next({ name: 'login' })
  } else if (to.name === 'login' && store.getters.isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
